import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  input,
  Output,
  viewChild,
} from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';
import { A11yModule } from '@angular/cdk/a11y';
import { CheckboxComponent } from '../../input/checkbox/checkbox.component';
import { OperationProgressComponent } from '../../operation-progress/operation-progress.component';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  imports: [CheckboxComponent, LottieComponent, A11yModule, OperationProgressComponent],
})
export class ModalConfirmationComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() icon: string | null;
  @Input() title: string;
  @Input() text: string;
  @Input() sameLineButtons: boolean;
  @Input() hideCancelButton?: boolean = false;
  @Input() width: string;
  @Input() centerText: boolean = false;
  @Input() htmlText: boolean = false;
  @Input() loading?: boolean = false;
  @Input() confirmText?: string;
  @Input() cancelText?: string;
  @Input() confirmStyle?: string = 'primary';
  @Input() cancelStyle?: string = 'secondary';
  @Input() extraInfoIcon?: string;
  @Input() extraInfoText?: string;
  @Input() extraInfoCheckbox?: string;
  readonly loadingPercentage = input<number | null>(null);
  readonly loadingDetail = input<string>('');
  @Output() action = new EventEmitter<any>();
  @Output() cancelAction = new EventEmitter<any>();
  readonly shown = input(false);
  readonly modalContainer = viewChild.required<ElementRef<HTMLElement>>('modalContainer');


  public images = images;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  extraInfoChecked: boolean = false;

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  onCheckboxChange(event: any) {
    this.extraInfoChecked = event.target.checked;
  }

  onConfirm() {
    this.action.emit(this.extraInfoCheckbox ? this.extraInfoChecked : true);
  }

  onCancel() {
    this.cancelAction.emit();
    this.modal.hide();
  }

  closeModal() {
    if (this.loading) return;
    this.modal.hide();
  }
}
